import CommonError from '../Common/CommonError'

const Error404Container = () => {
  return (
    <CommonError error="404" color="danger" src="sad3" />
  )
}

export default Error404Container